import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy"



import "./copy.png";
import Buy3 from "./component/buy3";
import Buy1 from "./component/buy1";




function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[direct1,setDirect1]=useState("None");
 const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");

  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [wid1,setwid1]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [a4,sea4]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const [l1,setl1]=useState("None");
const [b1,setb1]=useState("None");
const [l2,setl2]=useState("None");
const [b2,setb2]=useState("None");
const [l3,setl3]=useState("None");
const [b3,setb3]=useState("None");
const [l4,setl4]=useState("None");
const [b4,setb4]=useState("None");
const [l5,setl5]=useState("None");
const [b5,setb5]=useState("None");
const [l6,setl6]=useState("None");
const [b6,setb6]=useState("None");
const [l7,setl7]=useState("None");
const [b7,setb7]=useState("None");
const [l8,setl8]=useState("None");
const [b8,setb8]=useState("None");
const [l9,setl9]=useState("None");
const [b9,setb9]=useState("None");
const [l10,setl10]=useState("None");
const [b10,setb10]=useState("None");
const [l11,setl11]=useState("None");
const [b11,setb11]=useState("None");
const [l12,setl12]=useState("None");
const [b12,setb12]=useState("None");
const [l13,setl13]=useState("None");
const [b13,setb13]=useState("None");
const [l14,setl14]=useState("None");
const [b14,setb14]=useState("None");
const [l15,setl15]=useState("None");
const [b15,setb15]=useState("None");
const [lev,setlev]=useState("None");
const [pen,setpen]=useState("None");

const [reward,setreward]=useState("None");
const [reward1,setreward1]=useState("None");
const [reward2,setreward2]=useState("None");
const [reward3,setreward3]=useState("None");
const [reward4,setreward4]=useState("None");
const [reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");



  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0x06294e0e856b02da004cf7a013159019309ddcd0";
      const contractABI = abi.abi;
     
      const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0x7f6790B4885aac01d9862655bFE58B4aDFD59Fe1";
  }
  
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
      let alltasks1 = await contract.getMemos1(account[0]);
      setTasks1(alltasks1);
      const b =Number(alltasks[2]);
      const refer = (alltasks[1]);
     setrefer(refer);
     document.querySelector("#hid").value  = (alltasks[1]);
     const direct =Number(alltasks[3])/1000000000000000000;
     setDirect(direct);
     const direct1 =Number(alltasks[46]);
     setDirect1(direct1);
     const directs = Number(alltasks[3])/1000000000000000000;
     setDirects(directs);
     const level = Number(alltasks[4])/1000000000000000000;
     setLevel(level);

     const wlevel = Number(alltasks[13])/1000000000000000000;
     setLevelw(wlevel);

     const plevel = Number(alltasks[12])/1000000000000000000;
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[1]) ;
     

setpackage(pack);


const lev = Number(alltasks[54])/1000000000000000000 ;
setlev(lev);


const pack3 = Number(alltasks[14])/1000000000000000000 ;
     

setpackage3(pack3);

const reward1 = Number(alltasks[49]) ;
setreward1(reward1);
const reward2 = Number(alltasks[50]) ;
setreward2(reward2);
const reward3 = Number(alltasks[51]) ;
setreward3(reward3);
const reward4 = Number(alltasks[52]) ;
setreward4(reward4);
const reward5 = Number(alltasks[53]) ;
setreward5(reward5);


            

const pack1 = Number(alltasks[2]/1000000000000000000) ;
document.querySelector("#pp").value  = Number(alltasks[1]);


setpackage1(pack1);



     setB(b);

     const upd = (Number(alltasks[7]) ) /1000000000000000000  ;
          
     setupd(upd);

     const dd = Number(alltasks[5]);
          
     setDD(dd);

     const dd2 = Number(alltasks[5]);
          
     setDD2(dd2);

     const dd1 =  Date.now() / 1000;
     setDD1(dd1);


     const tt1 = Math.trunc((dd1 - dd) / (3660 * 24 )) ;
   //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
     
     settt1(tt1);

const tt2 = 10080 - Math.trunc((dd1 - dd2)/60) ;
       
       settt2(tt2);

      if(tt2<0)
      {
        const tt2 = 0;
       
       settt2(tt2);
      }
       
       

       
    // const roi1 = Number(alltasks[9]) / 100000;
          
    // seroi1(roi1);

    

    // document.querySelector("#wi1").value = roi2;
     
     const a1 = Number(alltasks1[0])-1;
          
     sea1(a1);
     const a3 = Number(alltasks1[2])/1000000000000000000;
          
     sea3(a3);
     const a4 = Number(alltasks1[3])/1000000000000000000;
          
     sea4(a4);
     const a2 = Number(alltasks1[1])/1000000000000000000;
     sea2(a2);   
     var rr = 0;
     const tt4 =  Number(alltasks[15])/1000000000000000000;
     settt4(tt4);
     

     const l1 = Number(alltasks[16]);
     setl1(l1);
     const l2 = Number(alltasks[17]);
     setl2(l2);

     const l3 = Number(alltasks[18]);
     setl3(l3);
     const l4 = Number(alltasks[19]);
     setl4(l4);
     const l5 = Number(alltasks[20]);
     setl5(l5);
     const l6 = Number(alltasks[21]);
     setl6(l6);
     const l7 = Number(alltasks[22]);
     setl7(l7);
     const l8 = Number(alltasks[23]);
     setl8(l8);
     const l9 = Number(alltasks[24]);
     setl9(l9);
     const l10 = Number(alltasks[25]);
     setl10(l10);
     const l11 = Number(alltasks[26]);
     setl11(l11);
     const l12 = Number(alltasks[27]);
     setl12(l12);
     const l13 = Number(alltasks[28]);
     setl13(l13);
     const l14 = Number(alltasks[29]);
     setl14(l14);
     const l15 = Number(alltasks[30]);
     setl15(l15);
     


     const b1 = Number(alltasks[31]);
     setb1(b1);
     const b2 = Number(alltasks[32]);
     setb2(b2);
     const b3 = Number(alltasks[33]);
     setb3(b3);
     const b4 = Number(alltasks[34]);
     setb4(b4);
     const b5 = Number(alltasks[35]);
     setb5(b5);
     const b6 = Number(alltasks[36]);
     setb6(b6);
     const b7 = Number(alltasks[37]);
     setb7(b7);
     const b8 = Number(alltasks[38]);
     setb8(b8);
     const b9 = Number(alltasks[39]);
     setb9(b9);
     const b10 = Number(alltasks[40]);
     setb10(b10);
     const b11 = Number(alltasks[41]);
     setb11(b11);
     const b12 = Number(alltasks[42]);
     setb12(b12);
     const b13 = Number(alltasks[43]);
     setb13(b13);
     const b14 = Number(alltasks[44]);
     setb14(b14);
     const b15 = Number(alltasks[45]);
     setb15(b15);
     
     

     const tt = Number(alltasks[47])/1000000000000000000;
     settt(tt);
     const wid1 = Number(alltasks[48])/1000000000000000000;
     setwid1(wid1);
     const pen = tt - wid1;
     setpen(pen);
  
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     const reward = reward1 + reward2 + reward3 + reward4 + reward5;
setreward(reward);
if(reward==1)
{
  const reward = 250;
  setreward(reward);
}
if(reward==2)
{
  const reward = 750;
  setreward(reward);
}
if(reward==3)
  {
    const reward = 1750;
    setreward(reward);
  }
  if(reward==4)
    {
      const reward = 4250;
      setreward(reward);
    }
    if(reward==5)
      {
        const reward = 9250;
        setreward(reward);
      }
     

     document.querySelector("#bal").value = tt3;
     const referlink = 'https://BVT SWAP.io/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;

console.log(pack);
     
        } else {
          alert("Please wait for network");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }

  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>

	 <section id="section-features" class="relative">
        <div class="gradient-edge-top op-2"></div>
        <div class="container relative z-2">
         
          <div class="row g-4">
            <div class="clearfix"></div>

            <div class="col-lg-4 col-sm-6 wow fadeInRight" data-wow-delay="0s">
              <div class="p-40 text-center rounded-10 bg-color-2 text-light">
                <h2 class="mb-1">BUY PRICE</h2>
                <p ><input type ="text" id ="test" width={"200px"} ></input></p>
				
                            <Buy state={state}  />
              </div>
            </div>
			  <div class="col-lg-4 col-sm-6 wow fadeInRight" data-wow-delay="0s">
              <div class="p-40 text-center rounded-10 bg-color-2 text-light">
                <h2 class="mb-1">SELL PRICE  </h2>
                <p><input type ="text" id ="test1nn" width={"200px"} ></input></p>
				<Buy1 state={state}  /> 
              </div>
            </div>
		

			 <div class="col-lg-4 col-sm-6 wow fadeInRight" data-wow-delay="0s">
              <div class="p-40 text-center rounded-10 bg-color-2 text-light">
                <h2 class="mb-1">1 BVT PRO (Buy)</h2>
                <p style={{fontSize:"1.8rem"}}>{a3} USDT</p>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6 wow fadeInRight" data-wow-delay="0s">
              <div class="p-40 text-center rounded-10 bg-color-2 text-light">
                <h2 class="mb-1">1 BVT PRO (Sell)</h2>
                <p style={{fontSize:"1.8rem"}}>{a4} USDT</p>
              </div>
            </div>
			 <div class="col-lg-4 col-sm-6 wow fadeInRight" data-wow-delay="0s">
              <div class="p-40 text-center rounded-10 bg-color-2 text-light">
                <h2 class="mb-1"> Tokens Purchased</h2>
                <p  style={{fontSize:"1.8rem"}}> {pack1} BVT PRO</p>
              </div>
            </div>
			 <div class="col-lg-4 col-sm-6 wow fadeInRight" data-wow-delay="0s">
              <div class="p-40 text-center rounded-10 bg-color-2 text-light">
                <h2 class="mb-1">Time To Next Sell</h2>
                <p  style={{fontSize:"1.8rem"}}>{tt2} Mins</p>
              </div>
            </div>
			 <div class="col-lg-4 col-sm-6 wow fadeInRight" data-wow-delay="0s">
              <div class="p-40 text-center rounded-10 bg-color-2 text-light">
                <h2 class="mb-1">MY PURCHASE</h2>
                <p  style={{fontSize:"1.8rem"}}>{pack} USDT</p>
              </div>
            </div>
			 <div class="col-lg-4 col-sm-6 wow fadeInRight" data-wow-delay="0s">
              <div class="p-40 text-center rounded-10 bg-color-2 text-light">
                <h2 class="mb-1"> Coin Sold</h2>
                <p  style={{fontSize:"1.8rem"}}>{upd} BVT PRO</p>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6 wow fadeInRight" data-wow-delay="0s">
              <div class="p-40 text-center rounded-10 bg-color-2 text-light">
                <h2 class="mb-1"> USDT Received</h2>
                <p  style={{fontSize:"1.8rem"}}>{direct} USDT</p>
              </div>
            </div>
				<div class="col-lg-4 col-sm-6 wow fadeInRight" data-wow-delay="0s">
              <div class="p-40 text-center rounded-10 bg-color-2 text-light">
                <h2 class="mb-1">My Wallet </h2>
                <p>{account}  </p>
              </div>
            </div>
				





			
			</div>
			</div>
			</section>

        

</div>  
  );
}

export default App;